export type AccessDataNetwork = { id: string, name: string };
export type AccessDataFunction = { id: string, name: string };

export type AccessData = {
  functions: AccessDataFunction[];
  networks: AccessDataNetwork[];
  name: string;
  brand_icon: string;
  theme: {
    login_image_url: string | null;
  };
};

// --- Trial generator (landing-page flow) -----------------------------------

export enum ETrialResearchStatus {
  IDLE = 'idle',
  RUNNING = 'running',
  DONE = 'done',
  PARTIAL = 'partial',
  FAILED = 'failed',
  STALE = 'stale',
}

export enum ETrialGenerationStatus {
  NOT_STARTED = 'not_started',
  GATE_RUNNING = 'gate_running',
  GATE_DONE = 'gate_done',
  ENRICH_RUNNING = 'enrich_running',
  ENRICH_DONE = 'enrich_done',
  GATE_FAILED = 'gate_failed',
  ENRICH_PARTIAL = 'enrich_partial',
}

export enum ETrialIndustrySets {
  BASE = 'base',
  SUPERMARKET = 'supermarket',
  APPAREL_FASHION = 'apparel_fashion',
  NON_FOOD_RETAIL = 'non_food_retail',
  HOTELS = 'hotels',
  RESTAURANTS = 'restaurants',
}

export const TRIAL_MODULE_KEYS = [
  'onboarding', 'academy', 'forms', 'surveys', 'performance',
  'communication', 'knowledge', 'events', 'schedule',
] as const;

export type TrialModuleKey = typeof TRIAL_MODULE_KEYS[number];

export type TrialResearchLocation = {
  place_id: string | null;
  name: string;
  city: string | null;
  is_head_office: boolean;
};

export type TrialResearchPreview = {
  name: string;
  logo_url: string | null;
  icon_url?: string | null;
  colors: { main: string; button: string; link: string } | null;
  industry_proposed: ETrialIndustrySets;
  confidence: number;
  locations: TrialResearchLocation[];
  locations_total_found: number;
  socials_found: string[];
  sources_failed: string[];
};

export type TrialResearchStatus = {
  status: ETrialResearchStatus;
  domain: string | null;
  preview: TrialResearchPreview | null;
  error: string | null;
  // Only on anonymous research (landing page).
  token?: string;
  expires_at?: string;
};

export type TrialGenerationStep = {
  key: string;
  phase: 'gate' | 'enrich';
  label: string;
  status: 'pending' | 'running' | 'done' | 'failed' | 'skipped';
  message: string | null;
  error: string | null;
  started_at: string | null;
  finished_at: string | null;
};

export type TrialGenerationStatus = {
  status: ETrialGenerationStatus;
  phase: 'gate' | 'enrich' | null;
  percent: number;
  steps: TrialGenerationStep[];
  error: { step?: string; message?: string } | null;
  research: { status: ETrialResearchStatus; sources_failed: string[] } | null;
};

/** What the visitor confirmed or changed in the preview; sent with create-trial. */
export type TrialLeadOverrides = {
  name: string;
  industry_set: ETrialIndustrySets;
  language_locale: 'nl' | 'en';
  locations: Array<{ place_id?: string | null; name: string; is_head_office: boolean }>;
  modules_of_interest: TrialModuleKey[];
};
